import {UI} from "../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../stem-core/src/ui/Style";

import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../stem-core/src/decorators/Style";
import {isSmallScreen} from "../../Utils";
import {Device} from "../../../stem-core/src/base/Device";
import {POPUP_GATE_TRANSITION_TIME} from "../../../blink-sdk/Constants";


class WidgetScrimStyle extends StyleSheet {
    transitionTime = POPUP_GATE_TRANSITION_TIME;

    @styleRule
    scrim = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 3,
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : 12,
        background: this.themeProps.WIDGET_SCRIM_BACKGROUND,
        opacity: 0,
        transition: this.transitionTime / 1000 + "s ease",
    };

    @styleRule
    visible = {
        opacity: 1,
    };
}

@registerStyle(WidgetScrimStyle)
export class WidgetScrim extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.scrim);
    }

    hide(timeout) {
        this.removeClass(this.styleSheet.visible);
        this.attachTimeout(() => this.destroyNode(), timeout);
    }

    onMount() {
        super.onMount();
        this.attachTimeout(() => this.addClass(this.styleSheet.visible));
    }
}
